import api from '../../api/_consultation-dmp'

const state = () => ({
    all_champ_dmp: [],
    dmp_by_type: [],
    dmp_contents: [],
    all_patient_dmp: [],
})

// getters
const getters = {
    all_champ_dmp: (state) => {
        return state.all_champ_dmp
    },

    dmp_by_type: (state) => {
        return state.dmp_by_type
    },

    dmp_contents: (state) => {
        return state.dmp_contents
    },

    all_patient_dmp: (state) => {
        return state.all_patient_dmp
    },
}

// mutations
const mutations = {
    SET_ALL_CHAMP_DMP(state, champ) {
        state.all_champ_dmp = champ
    },

    SET_DMP_BY_TYPE(state, dmp) {
        state.dmp_by_type = dmp
    },

    SET_DMP_CONTENTS(state, content) {
        state.dmp_contents = content
    },

    SET_ALL_PATIENT_DMP(state, dmp) {
        state.all_patient_dmp = dmp
    },
}

// actions
const actions = {
    getAllChampDmp({ commit }, type_dmp ) {
        return new Promise((resolve, reject) => {
            api.getAllChampDmp(type_dmp).then(
                response => {
                    commit('SET_ALL_CHAMP_DMP', response)
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    saveChampDMP({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            console.log("c dmp: ",data)
            api.saveChampDMP(data).then(
                response => {
                    resolve(response)
                    dispatch('getAllChampDmp', data.type_dmp)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getDmpByType({ commit }, data ) {
        return new Promise((resolve, reject) => {
            api.getDmpByType(data).then(
                response => {
                    commit('SET_DMP_BY_TYPE', response)
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getDmpContents({ commit }) {
        return new Promise((resolve, reject) => {
            api.getDmpContents().then(
                response => {
                    commit('SET_DMP_CONTENTS', response)
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    saveConsultationDmp({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.saveConsultationDmp(data).then(
                response => {
                    resolve(response)
                    dispatch('getAllChampDmp', data.type_dmp)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    removeConsultationDmpContent({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.removeConsultationDmpContent(data).then(
                response => {
                    resolve(response)
                    dispatch('getAllChampDmp', data.type_dmp)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getAllPatientDmp({ commit }, patient_id ) {
        return new Promise((resolve, reject) => {
            api.getAllPatientDmp(patient_id).then(
                response => {
                    commit('SET_ALL_PATIENT_DMP', response)
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },
}

export default {
    state,
    getters,
    mutations,
    actions
}